import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Customer } from '@features/customers/models/customer';
import { User } from '@features/users/models/user';
import { Lookup } from '@shared-features/models/Lookup.model';
import { LookupType } from '@shared/enums';
import { SharedConstants } from '@shared/model/shared-constants';

@Component({
  selector: 'app-filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.scss'],
})
export class FilterFormComponent {
  @Input() form: UntypedFormGroup;
  @Input() customers: Customer[] = [];
  @Input() creators: User[] = [];
  @Output() filterValues = new EventEmitter();
  sharedConstants = SharedConstants;
  readonly lookupType =  LookupType;
  addAllToOptions = this.onAddingAllToOptions.bind(this);

  onApply(){
    this.filterValues.emit(this.form.value);
  }

  onReset() {
    this.form.patchValue({
      customer: this.sharedConstants.ALL,
      creator: this.sharedConstants.ALL,
      customerSearchTerm: '',
      creatorSearchTerm: ''
    });
    this.filterValues.emit(this.form.value);
  }
  onAddingAllToOptions(options): Lookup[] {
    return [Object.assign(new Lookup(), { id:  this.sharedConstants.ALL, value:'Options.ALL'}),...options];
  }
}
